var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentImage !== undefined)?_c('div',{staticClass:"respondeco__background-image",class:{
    'respondeco__background-image--cover': _vm.cover === true,
    'rounded-circle': _vm.notRound === false,
  },style:({
    backgroundImage: ("url(" + _vm.currentImage + ")"),
    height: (_vm.height || 35) + 'px',
    width: (_vm.width || 35) + 'px',
  }),on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }